import { Pencil } from 'lucide-react';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/Tooltip.tsx';

const OVERRIDDEN_LABEL = 'Kwota nadpisana ręcznie';

interface OverriddenBadgeProps {
  /** Uzasadnienie operatora; bez niego dymek tłumaczy sam znacznik. */
  priceNote?: string;
}

/** Kwota spoza cennika; w dymku uzasadnienie operatora, gdy je wpisał. */
const OverriddenBadge = ({ priceNote }: OverriddenBadgeProps) => (
  <Tooltip>
    <TooltipTrigger asChild>
      <span
        aria-label={
          priceNote ? `${OVERRIDDEN_LABEL}: ${priceNote}` : OVERRIDDEN_LABEL
        }
        className="inline-flex size-[18px] shrink-0 items-center justify-center rounded-[5px] bg-accent-200 text-accent-900"
      >
        <Pencil aria-hidden className="size-3" />
      </span>
    </TooltipTrigger>
    <TooltipContent className="max-w-xs">
      {priceNote ?? OVERRIDDEN_LABEL}
    </TooltipContent>
  </Tooltip>
);

export default OverriddenBadge;
